"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.InputField = void 0;

var _stylitas = require("@creditas/stylitas");

var _base = require("./base.style");

var _inputField = require("./inputField.style");

const InputField = _stylitas.styled.div`
  ${_base.baseStyles};
  ${_base.inputStatus};
  ${props => props.inputHover && _base.inputHovered};
  &:hover {
    ${_base.inputHovered};
  }
  ${props => props.inputFocus && _base.inputFocused};
  &:focus-within {
    ${_base.inputFocused};
  }
  ${_base.inputDisabled};
  ${_base.inputReadOnly};
  ${_inputField.defaultDensity};
  ${_inputField.comfortableDensity};
  ${_inputField.compactDensity};
  ${_inputField.paddingOnFocusDefault};
  ${_inputField.paddingOnFocusComfortable};
  ${_inputField.paddingOnFocusCompact};
`;
exports.InputField = InputField;